<template>
  <div class="wrapper-landing">
    <LandingHero
      :title="content.hero.title"
      :subtitle="content.hero.subtitle"
      :origin="content.hero.origin"
      :lang="content.hero.lang"
      :buttonText="content.hero.buttonText"
    >
      <template v-slot:cover>
        <source
          media="(max-width: 991px)"
          :srcset="content.hero.cover.mobile"
          alt=""
          loading="lazy"
        />
        <img
          class="ln-hero__inset"
          :src="content.hero.cover.desktop"
          alt=""
          loading="lazy"
        />
      </template>
    </LandingHero>

    <main class="bg-cercles">
      <LandingAppRatings />

      <section class="bb-container">
        <LandingFeaturesSimple
          :title="content.features_simple.title"
          :use-carousel="false"
        >
          <LandingFeaturesSimpleItem
            v-for="(item, index) in content.features_simple.items"
            :key="`feature-simple-${index}`"
          >
            <template slot="ico">
              <img :src="item.icon" alt="" />
            </template>
            <template slot="title">
              {{ item.text }}
            </template>
          </LandingFeaturesSimpleItem>
        </LandingFeaturesSimple>
      </section>
    </main>

    <LandingFeaturesCover :title="content.features_cover.title">
      <LandingFeaturesCoverItem
        v-for="(item, index) in content.features_cover.items"
        :key="`feature-cover-${index}`"
      >
        <template slot="cover">
          <img :src="item.image" alt="" />
        </template>

        <template slot="titulo">
          {{ item.title }}
        </template>

        <template slot="descripcion">
          <p>{{ item.description }}</p>
        </template>

        <template v-if="item.footnote" slot="footnote">
          <p>{{ item.footnote }}</p>
        </template>
      </LandingFeaturesCoverItem>
    </LandingFeaturesCover>

    <main class="bg-cercles">
      <section class="bb-container">
        <div class="ln-reviews">
          <header class="ln-head ln-head--sm">
            <div class="ln-head__titulo ln-head__titulo--h3">
              {{ content.reviews.title }}
            </div>
          </header>

          <div class="ln-reviews__items">
            <VueSlickCarousel v-bind="reviewsSection">
              <div
                v-for="(review, index) in content.reviews.items"
                :key="`review-${index}`"
                class="ln-reviews__item"
              >
                <div class="b-card">
                  <div class="testimonial-item">
                    <div class="testimonial-item__text">
                      "{{ review.text }}"
                    </div>
                    <div class="testimonial-item__name">
                      {{ review.name }}
                    </div>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </section>
    </main>

    <LandingComoCols
      :title="content.how_it_works.title"
      :subtitle="content.how_it_works.subtitle"
    >
      <LandingComoColsItem
        v-for="(step, index) in content.how_it_works.steps"
        :key="`step-${index}`"
      >
        <template slot="icono">
          <img :src="step.icon" alt="" />
        </template>

        <template slot="titulo">
          {{ step.title }}
        </template>

        <template slot="descripcion">
          <p
            v-for="(paragraph, pIndex) in step.description"
            :key="`step-${index}-p-${pIndex}`"
          >
            {{ paragraph }}
          </p>
        </template>
      </LandingComoColsItem>
    </LandingComoCols>

    <LandingFooter :lang="content.footer.lang" />
  </div>
</template>

<script>
import landingContent from "./babyregistry.en.json";

import LandingFeaturesSlider from "./components/LandingFeaturesSlider.vue";
import LandingFeaturesSimple from "./components/LandingFeaturesSimple.vue";
import LandingFeaturesSimpleItem from "./components/LandingFeaturesSimpleItem.vue";
import LandingHero from "./components/LandingHero.vue";
import LandingAppRatings from "./components/LandingAppRatings.vue";
import LandingFeaturesCover from "./components/LandingFeaturesCover";
import LandingFeaturesCoverItem from "./components/LandingFeaturesCoverItem";
import LandingReviews from "./components/LandingReviews.vue";
import LandingHablan from "./components/LandingHablan.vue";
import LandingReviewsWedding from "./components/LandingReviewsWedding.vue";
import LandingFooter from "./components/LandingFooter.vue";
import LandingComoCards from "./components/LandingComoCards.vue";
import LandingComoCardsItem from "./components/LandingComoCardsItem.vue";
import LandingComoColsItem from "./components/LandingComoColsItem.vue";
import LandingComoCols from "./components/LandingComoCols.vue";
import FeaturesCoverItemListUpdate from "./components/FeaturesCoverItemListUpdate.vue";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "LandingBabyRegistryEN",

  metaInfo() {
    return {
      title: this.content.meta.title,
      htmlAttrs: {
        lang: this.content.meta.lang,
      },
      meta: [
        { name: "description", content: this.content.meta.description },
        { name: "robots", content: this.content.meta.robots },
      ],
    };
  },

  components: {
    LandingComoCols,
    LandingComoColsItem,
    LandingAppRatings,
    LandingHablan,
    LandingReviews,
    LandingFooter,
    LandingHero,
    LandingFeaturesCover,
    LandingFeaturesCoverItem,
    LandingFeaturesSlider,
    LandingFeaturesSimple,
    LandingFeaturesSimpleItem,
    LandingComoCards,
    LandingComoCardsItem,
    LandingReviewsWedding,
    FeaturesCoverItemListUpdate,
    VueSlickCarousel,
  },

  data() {
    return {
      content: landingContent,
      reviewsSection: {
        slidesToShow: 4,
        arrows: false,
        responsive: [
          {
            breakpoint: 9999,
            settings: "unslick",
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              draggable: true,
              centerPadding: "50px",
              dots: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              draggable: true,
              dots: true,
            },
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
